import { Tabs } from "@newsela/angelou";

import { Challenge } from "@/challenges/utils/interfaces";
import {
  tabListStyle,
  tabPanelsStyle,
  tabsContainerStyle,
} from "./ChallengesFolder.style";
import FolderContents from "./FolderContents";

interface ChallengesFolderProps {
  isHomeVersion?: boolean;
  challengesData: Challenge[] | null;
}

const ChallengesFolder = ({
  isHomeVersion = false,
  challengesData,
}: ChallengesFolderProps) => {
  if (!challengesData?.length) return null;

  return (
    <Tabs
      horizontalSwitch="xs"
      __cssFor={{
        root: tabsContainerStyle,
        tabList: tabListStyle,
        tabPanels: tabPanelsStyle,
      }}
      initialPanelId={challengesData[0]?.challenge_id || ""}
      panels={challengesData.map((challenge) => ({
        panelId: challenge.challenge_id,
        name: challenge.subject,
        panelContent: (
          <FolderContents isHomeVersion={isHomeVersion} challenge={challenge} />
        ),
      }))}
    />
  );
};

export default ChallengesFolder;
